<template>
  <div>
    <div class="page page__list" v-if="!isFAC">
      <search-bar
        @search="onSearch"
        name="fa_user,fa_deptname"
        placeholder="输入使用人、使用部门进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/oa/fixed_assets/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.fa_code}}</p>
            <p class="list-item-muted">{{item.fa_name}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.fa_user}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.fa_status!='已审核'}"
            >{{item.fa_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}笔</label>
      </div>
    </div>

    <div class="page page__list" v-if="isFAC">
      <search-bar
        @search="onSearch"
        name="fa_code,fa_name,fa_class,fa_model,fa_brand"
        placeholder="输入资产编号、名称、类别、型号或品牌查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/oa/fixed_assets_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.fc_facode}}</p>
            <p class="list-item-muted">{{item.fa_name}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.fc_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.fc_status!='已审核'}"
            >{{item.fc_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}个</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isFAC: false,
      listUrl: "/api/oa/fixedassets/list",
      filters: [
        {
          type: "date",
          name: "fa_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "未审核",
              condition: "fa_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "fa_statuscode='AUDITED'"
            },
            {
              value: 3,
              label: "待变更",
              condition: "fc_statuscode='UNAUDITED'"
            },
            {
              value: 4,
              label: "已变更",
              condition: "fc_statuscode='AUDITED'"
            },
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value > 2
      this.listUrl = isChange ? '/api/oa/fixedassetschange/list' : '/api/oa/fixedassets/list'
      this.filters[0].name = isChange ? 'fixedassetschange.createTime' : 'fa_date'
      this.isFAC = isChange ? true : false
      filterBar.initConfig()
      next()
    },
  }
}
</script>